import { render, staticRenderFns } from "./EmployeeSickLeave.vue?vue&type=template&id=2ef5f9a4&scoped=true"
import script from "./EmployeeSickLeave.vue?vue&type=script&lang=js"
export * from "./EmployeeSickLeave.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSickLeave.vue?vue&type=style&index=0&id=2ef5f9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5f9a4",
  null
  
)

export default component.exports